/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductInfoType = {
    SERVICE: 'SERVICE',
    PROPERTY: 'PROPERTY',
    PRODUCT: 'PRODUCT',
    INGREDIENT: 'INGREDIENT',
    DELIVERY: 'DELIVERY',
    MATERIAL_ASSETS: 'MATERIAL_ASSETS',
    NON_MATERIAL_ASSETS: 'NON_MATERIAL_ASSETS'
} as const;
export type ProductInfoType = typeof ProductInfoType[keyof typeof ProductInfoType];

